module.exports = __webpack_public_path__ + "static/media/code3.02414edf.PNG";